import { render, staticRenderFns } from "./POI.vue?vue&type=template&id=043653b5"
import script from "./POI.vue?vue&type=script&lang=js"
export * from "./POI.vue?vue&type=script&lang=js"
import style0 from "./POI.vue?vue&type=style&index=0&id=043653b5&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports